var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1049 10.5149L10.7099 18.8399C9.53993 19.7699 8.78991 21.7349 9.04491 23.2049L11.0399 35.1449C11.3999 37.2749 13.4399 38.9999 15.5999 38.9999H32.3999C34.5449 38.9999 36.5999 37.2599 36.9599 35.1449L38.9549 23.2049C39.1949 21.7349 38.4449 19.7699 37.2899 18.8399L26.8949 10.5299C25.2899 9.23994 22.6949 9.23992 21.1049 10.5149Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.555 31.6797C23.94 31.6797 23.445 31.1847 23.43 30.5847C23.385 28.5597 22.05 27.2247 20.025 27.1797C19.41 27.1647 18.915 26.6547 18.93 26.0247C18.945 25.4097 19.44 24.9297 20.055 24.9297C20.07 24.9297 20.07 24.9297 20.085 24.9297C23.31 25.0047 25.62 27.2997 25.68 30.5247C25.695 31.1397 25.2 31.6647 24.585 31.6797C24.585 31.6797 24.57 31.6797 24.555 31.6797Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 31.6797C28.44 31.6797 27.93 31.1847 27.93 30.5697C27.915 29.5797 27.75 28.6347 27.45 27.7497C26.685 25.5597 25.05 23.9397 22.86 23.1597C21.975 22.8447 21.03 22.6797 20.04 22.6797C19.425 22.6797 18.915 22.1697 18.93 21.5397C18.93 20.9247 19.44 20.4297 20.055 20.4297H20.07C21.315 20.4447 22.5 20.6547 23.61 21.0447C26.445 22.0497 28.56 24.1647 29.565 26.9997C29.955 28.1097 30.165 29.3097 30.18 30.5397C30.195 31.1697 29.7 31.6797 29.055 31.6797C29.07 31.6797 29.07 31.6797 29.055 31.6797Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0703 32.0703C19.2303 32.0703 18.5703 31.3953 18.5703 30.5703C18.5703 29.7453 19.2453 29.0703 20.0703 29.0703C20.8953 29.0703 21.5703 29.7453 21.5703 30.5703C21.5703 31.3953 20.8953 32.0703 20.0703 32.0703Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHome);
export default __webpack_public_path__ + "static/media/smartHome.db198b450bc4b88b81492f0e0015b7bc.svg";
export { ForwardRef as ReactComponent };